import React, { useState, useCallback } from 'react';
import ExpansionPanel, { ExpansionList } from 'react-md/lib/ExpansionPanels';
import { selectIsLoading } from 'State/Redux/AsyncRedux';
import { useDispatch, useSelector } from 'react-redux';
import FeeMaintenanceResultsPanel from './Panels/FeeMaintenanceResultsPanel';
import {
   FeeMaintenanceActions,
   selectFeeMaintenances,
   FeeMaintenanceTypes,
} from 'State/Redux/FeeMaintenanceRedux';
import { FN_EMPTY_VOID } from 'Util/Helpers/Empty';
import SearchPanel from './Panels/SearchPanel';
import { FeeMaintenanceSearchQuery } from 'Models/FeeMaintenance/Dto/FeeMaintenanceSearchQuery';

const SearchFeeMaintenance = (): JSX.Element => {
   const searchResults = useSelector(selectFeeMaintenances);
   const isLoading = useSelector(
      selectIsLoading([FeeMaintenanceTypes.GET_FEE_MAINTENANCE_REQUEST])
   );
   const dispatch = useDispatch();

   const [hasSearched, setHasSearched] = useState(false);

   const searchBoardMeetingDates = useCallback(
      (query: FeeMaintenanceSearchQuery): void => {
         dispatch(FeeMaintenanceActions.getFeeMaintenanceRequest(query));
         setHasSearched(true);
      },
      [dispatch]
   );
   const resetSearch = useCallback((): void => setHasSearched(false), []);
   const isSearching = isLoading && hasSearched;

   const panelTitle = searchResults
      ? `Results (${searchResults.length})`
      : 'Results';

   return (
      <ExpansionList className="md-cell md-cell--12 find-tab">
         <ExpansionPanel
            label="Search"
            footer={null}
            expanded
            expanderIcon={<></>}
            onExpandToggle={FN_EMPTY_VOID}
         >
            <SearchPanel
               searchBoardMeetingDates={searchBoardMeetingDates}
               isSearching={isSearching}
               resetSearch={resetSearch}
            />
         </ExpansionPanel>
         {hasSearched ? (
            <ExpansionPanel
               label={panelTitle}
               footer={null}
               expanded
               expanderIcon={<></>}
               onExpandToggle={FN_EMPTY_VOID}
            >
               <FeeMaintenanceResultsPanel
                  isLoading={isLoading}
                  searchResults={searchResults || []}
               />
            </ExpansionPanel>
         ) : (
            <></>
         )}
      </ExpansionList>
   );
};

export default SearchFeeMaintenance;
